
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/representatives",
      function () {
        return require("private-next-pages/representatives/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/representatives"])
      });
    }
  